export const RELOAD_RTE_TIME = 30000; // ms

export const RELOAD_TIME = 30000; // ms

export const COPIED_TIME = 2000; // ms

export const RELOAD_TIME_DATA_QUALITY = 60000; // ms

export const DEEP_DIVE_RELOAD_TIME = 300000; // ms

export const TRAJECTORY_RELOAD_TIME = 600000; // ms

export const INTERVAL_FETCH_IN_MICROSECONDS = 300000; // ms

export const INTERVAL_FETCH_MACROSCHEMA_ELEMENT_IN_MICROSECONDS = 3600000; // one hour in ms
